'use client';

import { useEffect } from 'react';
import { ONE_TRUST_GROUPS } from '../../analytics/const';

function hasConsent(groupStr = '') {
	const groups = new Set(groupStr.split(','));
	return groups.has(ONE_TRUST_GROUPS.performance) && groups.has(ONE_TRUST_GROUPS.functional);
}

export function AdobeLaunchScript({ env }: { env?: string }) {
	let scriptId = '';

	switch (env) {
		case 'production':
		case 'prd':
			scriptId = '627342fb0250';
			break;
		case 'uat':
		case 'prev':
			scriptId = '6be2469f5d2c-staging';
			break;
		default:
			scriptId = '5ac24c15dfaf-development';
			break;
	}

	useEffect(() => {
		const load = () => {
			if (document.getElementById('adobe-launch')) return;

			const s = document.createElement('script');
			s.id = 'adobe-launch';
			s.src = `https://assets.adobedtm.com/57e62086a19e/7ac6a41c0df3/launch-${scriptId}.min.js`;
			s.async = true;
			document.head.appendChild(s);
		};

		const onUpdate = () => {
			if (hasConsent(window.OnetrustActiveGroups)) load();
		};

		onUpdate();

		window.addEventListener('OneTrustGroupsUpdated', onUpdate);

		return () => {
			window.removeEventListener('OneTrustGroupsUpdated', onUpdate);
		};
	}, [scriptId]);

	return null;
}
